module.exports = __webpack_public_path__ + "static/media/dr-ramsay-old.7f25e656.jpg";